// Property Fees Section - All fee fields
import React from 'react';
import { FormSection, NumericFormField } from '@/components/common/admin/form';

interface PropertyFeesSectionProps {
  propertyNsfFee: string;
  propertyLateDayStart: string;
  propertyLateDayFee: string;
  propertyLateDailyFee: string;
  propertyMaxMonthlyFee: string;
  nsfFeeError?: string;
  lateDayFeeError?: string;
  lateDailyFeeError?: string;
  maxMonthlyFeeError?: string;
  onNsfFeeChange: (value: string) => void;
  onLateDayStartChange: (value: string) => void;
  onLateDayFeeChange: (value: string) => void;
  onLateDailyFeeChange: (value: string) => void;
  onMaxMonthlyFeeChange: (value: string) => void;
  disabled?: boolean;
}

export const PropertyFeesSection: React.FC<PropertyFeesSectionProps> = ({
  propertyNsfFee,
  propertyLateDayStart,
  propertyLateDayFee,
  propertyLateDailyFee,
  propertyMaxMonthlyFee,
  nsfFeeError,
  lateDayFeeError,
  lateDailyFeeError,
  maxMonthlyFeeError,
  onNsfFeeChange,
  onLateDayStartChange,
  onLateDayFeeChange,
  onLateDailyFeeChange,
  onMaxMonthlyFeeChange,
  disabled,
}) => {
  return (
    <FormSection title="Property Fees">
      <NumericFormField
        label="NSF Fee"
        value={propertyNsfFee}
        onChangeText={onNsfFeeChange}
        placeholder="30"
        error={nsfFeeError}
        required
        editable={!disabled}
      />

      <NumericFormField
        label="Late Day Start"
        value={propertyLateDayStart}
        onChangeText={onLateDayStartChange}
        placeholder="5"
        editable={!disabled}
      />

      <NumericFormField
        label="Late Day Fee"
        value={propertyLateDayFee}
        onChangeText={onLateDayFeeChange}
        placeholder="5"
        error={lateDayFeeError}
        required
        editable={!disabled}
      />

      <NumericFormField
        label="Late Daily Fee"
        value={propertyLateDailyFee}
        onChangeText={onLateDailyFeeChange}
        placeholder="5"
        error={lateDailyFeeError}
        required
        editable={!disabled}
      />

      <NumericFormField
        label="Max Fee Per Month"
        value={propertyMaxMonthlyFee}
        onChangeText={onMaxMonthlyFeeChange}
        placeholder="150"
        error={maxMonthlyFeeError}
        required
        editable={!disabled}
      />
    </FormSection>
  );
};

